const comparator = {
  methods: {
    comparator(a, b) {
      return a == b;
    }
  }
};

export default comparator;
